import { jsxs, jsx } from "react/jsx-runtime";
import { Children, isValidElement } from "react";
import PropTypes from "prop-types";
import { CardsWrapper, CardsItem, CardsFooter } from "./cards.styles.es.js";
const propTypes = {
  children: PropTypes.node,
  footer: PropTypes.node,
  grow: PropTypes.bool,
  view: PropTypes.oneOf(["list", "grid"])
};
const defaultProps = {
  children: void 0,
  footer: void 0,
  grow: false,
  view: "grid"
};
const Cards = ({ children, footer, grow, view }) => /* @__PURE__ */ jsxs(CardsWrapper, { grow, view, children: [
  Children.map(
    children,
    (child) => isValidElement(child) && /* @__PURE__ */ jsx(CardsItem, { view, children: child }, child.key)
  ),
  footer && /* @__PURE__ */ jsx(CardsFooter, { children: footer })
] });
Cards.propTypes = propTypes;
Cards.defaultProps = defaultProps;
export {
  Cards
};
